var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('keep-alive',[(_vm.ifAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.ifAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-580e49ea","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 3wpm
// module chunks = 52